import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Caption1 } from "@activecollab/components";
import classnames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import useAcSelectDate from "~/components/Hooks/useAcSelectDate.jsx";
import { formatLocalDate, formatLocalTime } from "../../../../../../utils/date.jsx";
import AvatarContainer from "../../../../../Users/AvatarContainer.jsx";
import UserNameContainer from "../../../../../Users/UserNameContainer.jsx";

export const SystemsMessage = ({ createdById, createdOn, formatTime, formatDate, messageText }) => {
  const { t } = useTranslation();
  const { today } = useAcSelectDate();

  const formatDateTime = useCallback(
    (value) => {
      const yesterday = today.clone().subtract(1, "day");

      if (today.format("YYYY-MM-DD") === moment.unix(value).format("YYYY-MM-DD")) {
        return `${t("Today at")} ${formatLocalTime(value, formatTime)}`;
      }
      if (yesterday.format("YYYY-MM-DD") === moment.unix(value).format("YYYY-MM-DD")) {
        return `${t("Yesterday at")} ${formatLocalTime(value, formatTime)}`;
      }
      return `${formatLocalDate(value, formatDate, false)} ${t("at")} ${formatLocalTime(value, formatTime)} `;
    },
    [formatDate, formatTime, t, today]
  );

  const createdOnFormat = useMemo(() => {
    return formatDateTime(createdOn);
  }, [createdOn, formatDateTime]);

  return (
    <div
      className={classnames("tw-flex tw-items-center tw-justify-self-center systems-message tw-p-1 tw-pr-3 tw-mb-3")}
      title={createdOnFormat}
    >
      <AvatarContainer
        id={createdById}
        size={24}
        className="tw-mr-2"
      />
      <Caption1>
        <UserNameContainer
          userId={createdById}
          shortName
        />{" "}
        {messageText}
      </Caption1>
    </div>
  );
};

SystemsMessage.propTypes = {
  createdById: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  createdOn: PropTypes.number.isRequired,
  messageText: PropTypes.string,
  formatTime: PropTypes.string,
  formatDate: PropTypes.string,
};
